import { useEffect } from 'react'
import { ReactSVG } from 'react-svg'
import icon from '../assets/logo.svg'
import { usePreferences } from '../hooks'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { BannerActions } from './BannerActions'

type CompanyBanner = {
  envId: string | undefined
  apiKey: string | undefined
  error: string | undefined
  isLoading: boolean
}

const CompanyBanner = (props: CompanyBanner) => {
  const { data, isLoading } = usePreferences(
    props.envId ?? '',
    props.apiKey ?? ''
  )

  useEffect(() => {
    if (data?.tabTitle) document.title = data?.tabTitle

    if (data?.base64Favicon) {
      const favicon = document.querySelector(
        'link[rel="icon"]'
      ) as HTMLLinkElement

      if (favicon) favicon.href = data?.base64Favicon ?? ''
    }
  }, [data])

  return (
    <Box
        display="flex"
        flex={1}
        alignItems="start"
        width="100%"
        justifyContent="center"
        flexDirection="column"
        sx={{ maxWidth: 400 }}
      >
        {props.isLoading || isLoading ? (
          <Skeleton width={80} height={80} variant="circular" />
        ) : data?.connectLogoData ? (
          <Box
            maxWidth={80}
            maxHeight={80}
            component="img"
            src={data?.connectLogoData}
            alt=""
          />
        ) : (
          <ReactSVG src={icon} beforeInjection={(svg) => {
            svg.setAttribute('width', '80')
            svg.setAttribute('height', '80')
          }} />
        )}
        <Typography
          variant="h1"
          sx={{ mt: 4, fontSize: '2.4rem', fontWeight: 600, letterSpacing: '-0.02em' }}
        >
          {props.isLoading || isLoading ? (
            <Skeleton width={200} variant="text" />
          ) : (
            data?.connectTitle ?? 'Connect to hotglue'
          )}
        </Typography>
        <Typography
          variant="body1"
          textAlign="left"
          sx={{ mt: 2, color: props.error ? 'error.main' : 'text.tertiary', lineHeight: 1.5 }}
        >
          {props.isLoading || isLoading ? (
            <Skeleton width={280} variant="text" />
          ) : props.error ? (
            data?.connectError || props.error + ', please contact the admin.'
          ) : (
            data?.connectDescription || 'Start connecting your apps to Hotglue. Select a provider to get started.'
          )}
        </Typography>
        <Box mt={4}>
          <BannerActions
            envId={props.envId}
            apiKey={props.apiKey}
            isLoading={props.isLoading}
          />
        </Box>
      </Box>
  )
}

export default CompanyBanner
